import { IAutoMapper } from "../../core/automapper/interfaces";
import { BooleanHelper } from "../../utilities/contracts/boolean-helper";
import { StringHelper } from "../../utilities/contracts/string-helper";

export const mapMenuItems = (automapper: IAutoMapper): void => {

    automapper
        .createMap("default-sub-menu", "MenuItem")
        .forMember("description", o => o.description)
        .forMember("path", o => o.path)
        .forMember("iconName", o => o.iconName)
        .forMember("show", o => o.show);

    automapper
        .createMap("default", "MenuItem")
        .forMember("description", o => o.label)
        .forMember("path", o => o.routerLink)
        .forMember("iconName", o => o.icon)
        .forMember("show", o => o.show)
        .forMember("children", o => {
            const isArray = Array.isArray(o.items) && o.items.length > 0;

            return isArray ? automapper.mapMany("default", "MenuItem", o.items) : [];
        });
};

export class MenuItem {
    readonly description: string;
    readonly path: string;
    readonly iconName: string;
    readonly children: MenuItem[];
    show: boolean;


    constructor(options: {
        description: string;
        path: string;
        iconName?: string;
        children?: MenuItem[];
        show?: boolean;
    }) {
        StringHelper.throwIsAvailableError(options.description, "description");
        StringHelper.throwIsAvailableError(options.path, "path");

        this.description = StringHelper.clean(options.description);
        this.path = StringHelper.clean(options.path);
        this.iconName = StringHelper.clean(options.iconName).toLowerCase();
        this.children = options.children || [];
        this.show = BooleanHelper.tryGet(options.show, true);
    }

    get hasIconName(): boolean {
        return StringHelper.isAvailable(this.iconName);
    }

    get hasChildren(): boolean {
        return this.children.length > 0;
    }
}
